import * as itemV4 from './item-v4'
export default {
  ...itemV4,
}
